const filter = document.getElementById("filter");
const postcodes = document.querySelectorAll("#post__code-table-code");
const postCodeTableCol = document.querySelector(".post__code-table-col");

function filterPostcodes() {
  const text = filter.value.toLowerCase();

  postcodes.forEach((el) => {
    const currentEl = el.firstChild.textContent.toLowerCase();
    const parentElement = el.parentElement;

    if (currentEl.includes(text)) {
      parentElement.style.display = "grid";
    } else {
      parentElement.style.display = "none";
    }
  });

  const allHidden = [...postcodes].every((el) => el.parentElement.style.display === "none");

  if (allHidden) {
    showNoResultsMessage();
  } else {
    hideNoResultsMessage();
  }
}

function showNoResultsMessage() {
  let message = postCodeTableCol.querySelector(".no-results-message");

  if (!message) {
    message = document.createElement("div");
    message.textContent = "Sorry, we don't deliver to your area!";
    message.className = "no-results-message";
    postCodeTableCol.appendChild(message);
  }
}

function hideNoResultsMessage() {
  const message = postCodeTableCol.querySelector(".no-results-message");

  if (message) {
    postCodeTableCol.removeChild(message);
  }
}

filter.addEventListener("keyup", filterPostcodes);

/**/

function filterPostcodes() {
  const text = filter.value.toLowerCase();
  let resultsFound = false; // Variable to track if any results are found

  postcodes.forEach((el) => {
    const currentEl = el.firstChild.textContent.toLowerCase();
    const parentElement = el.parentElement;

    if (currentEl.includes(text)) {
      parentElement.style.display = "grid";
      resultsFound = true; // Set to true if any result matches the filter
    } else {
      parentElement.style.display = "none";
    }
  });

  if (resultsFound) {
    showSuccessMessage();
  } else {
    hideSuccessMessage();
  }
}

function showSuccessMessage() {
  let message = postCodeTableCol.querySelector(".success-message");

  if (!message) {
    message = document.createElement("div");
    message.textContent = "We deliver to your area!";
    message.className = "success-message";
    postCodeTableCol.appendChild(message);
  }
}

function hideSuccessMessage() {
  const message = postCodeTableCol.querySelector(".success-message");

  if (message) {
    postCodeTableCol.removeChild(message);
  }
}

filter.addEventListener("keyup", filterPostcodes);

